import React, { useState, useRef, useEffect } from "react";
import "./styles.css";
import { DefaultAvatar } from "../DefaultAvatar";
import { ReactComponent as TelegramIcon } from "../../../assets/icons/social/telegram.svg";
import { ReactComponent as WhatsappIcon } from "../../../assets/icons/social/whatsapp.svg";
import { ReactComponent as InstagramIcon } from "../../../assets/icons/social/instagram.svg";
import { ReactComponent as Chevron } from "../../../assets/icons/chevron.svg";
import { formatInternationalPhone, formatPhoneForDisplay, getPhoneHref } from "../../../utils";

export const UserCard = ({ user }) => {
  const [showSocials, setShowSocials] = useState(false);
  const socialsRef = useRef(null);

  const phone = formatPhoneForDisplay(user?.phone);
  const phoneHref = getPhoneHref(user?.phone);
  const shouldRenderSocials = user?.whatsapp || user?.telegram || user?.instagram;

  const toggleSocials = () => {
    setShowSocials((prev) => !prev);
  };

  useEffect(() => {
    if (socialsRef.current) {
      socialsRef.current.style.height = showSocials
          ? `${socialsRef.current.scrollHeight}px`
          : "0px";
    }
  }, [showSocials]);

  const whatsappPhone = formatInternationalPhone(user?.whatsapp)?.replace(/\D/g, "");
  const whatsappLink = whatsappPhone ? `https://wa.me/${whatsappPhone}` : null;
  const telegramLink = user?.telegram && `https://t.me/${user.telegram}`;
  const instagramLink = user?.instagram && `https://instagram.com/${user.instagram}`;

  return (
      <div className="usercard_container">
        <div className="usercard_row">
          <div className="usercard_avatar">
            <DefaultAvatar name={user?.name} color={user?.avatarColor} />
          </div>
          <div className="usercard_main-info">
            <div className="usercard_name">{user?.name}</div>
            {phone && phoneHref ? (
              <div className="usercard_phone">
                <a href={phoneHref} className="usercard_phone-link">
                  {phone}
                </a>
              </div>
            ) : null}
          </div>
          {shouldRenderSocials && (
              <div className="usercard_toggle" onClick={toggleSocials}>
                <Chevron className={`usercard_chevron ${showSocials ? "open" : ""}`} />
              </div>
          )}
        </div>

        <div ref={socialsRef} className="usercard_socials">
          <div className="usercard_row">
            <div className="usercard_secondary-info">
              <ul className="usercard_contacts">
                {user?.whatsapp && (
                    <li className="usercard_contact">
                      <a
                          href={whatsappLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="usercard_contact-link"
                      >
                        <WhatsappIcon width="44px" height="44px" />
                        {user.whatsapp}
                      </a>
                    </li>
                )}
                {user?.telegram && (
                    <li className="usercard_contact">
                      <a
                          href={telegramLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="usercard_contact-link"
                      >
                        <TelegramIcon width="44px" height="44px" />
                        {user.telegram}
                      </a>
                    </li>
                )}
                {user?.instagram && (
                    <li className="usercard_contact">
                      <a
                          href={instagramLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="usercard_contact-link"
                      >
                        <InstagramIcon width="44px" height="44px" />
                        {user.instagram}
                      </a>
                    </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
  );
};
